module.exports = __webpack_public_path__ + "static/img/adv4.5ee0d8b1.png";